import { get } from "lodash";

const config = (data) => ({
  ...data,

  executive_project_work_package_id:
    get(data, "executive_project_work_package_id", 0) === 0
      ? null
      : get(data, "executive_project_work_package_id"),
});
export default config;
